import { useCallback, useRef } from 'react';

import { useGlobalModalsSlice } from '@/stores/selectors';
import { GlobalModalProps, GlobalModalsKeys } from '@/stores/slices/global-modals-slice';

export const useGlobalModal = <T extends GlobalModalsKeys>(
  key: T,
  modalProps?: GlobalModalProps[T],
) => {
  const { globalModals, handleClose, handleOpen, props } = useGlobalModalsSlice();

  const handleOpenCallback = useCallback(
    () => handleOpen(key, modalProps),
    [key, modalProps, handleOpen],
  );
  const handleCloseCallback = useCallback(() => handleClose(key), [key, handleClose]);

  const isOpen = globalModals[key];

  const lastPropsRef = useRef<GlobalModalProps[T] | null>(null);
  if (isOpen) {
    lastPropsRef.current = props as GlobalModalProps[T];
  }

  return {
    open: isOpen,
    handleOpen: handleOpenCallback,
    handleClose: handleCloseCallback,
    props: isOpen ? (props as GlobalModalProps[T]) : lastPropsRef.current,
  };
};
